import { useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error Untyped import
import { selectSearchFilter } from '../../selectors/reportsSelector';
// @ts-expect-error Untyped import
import { useShowDialog } from 'reporting-action-components/dialog/ducks';
import { Button } from 'foundations-components/transitional/components/Button';
import { SINGLE_REPORT_VIEWER } from 'reporting-action-components/dialog/dialogTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReadyMadeReportsTableRow = ({
  template
}) => {
  const showDialog = useShowDialog();
  const search = useSelector(selectSearchFilter);
  const handleClick = () => {
    trackEvent(EVENTS.openSearchResultTemplate, {
      templateKey: template.get('templateKey'),
      filterValue: search,
      subscreen: 'global-search',
      isAiPowered: false
    });
    trackEvent(EVENTS.openReport, {
      templateKey: template.get('templateKey')
    });
    showDialog({
      dialogType: SINGLE_REPORT_VIEWER,
      dialogProps: {
        report: template
      }
    });
  };
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: handleClick,
        children: template.get('name')
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-100",
        children: template.get('description')
      })
    })]
  });
};
export default ReadyMadeReportsTableRow;